export default __webpack_public_path__ + "static/integratesWithMultipleApp-d6532477c0b4ecd5950a2b5dac8bcd4e.webp";